import React from 'react';
import { FDPaper } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import PropTypes from 'prop-types';
import { RaisedPaper } from './RaisedPaper';


export const PaymentMethodCard = ({ isCurrent, children }) => {
  const isMobile = useMobileLayout();
  const commonProps = {
    padding: 3,
    minWidth: !isMobile ? '400px' : undefined,
  };

  if (isCurrent) {
    return (
      <RaisedPaper
        {...commonProps}
        color={'success'}
      >
        { children }
      </RaisedPaper>
    );
  }
  return (
    <FDPaper
      {...commonProps}
      appearance={'elevated'}
    >
      {children}
    </FDPaper>
  );
};

PaymentMethodCard.defaultProps = {
  children: null,
};

PaymentMethodCard.propTypes = {
  isCurrent: PropTypes.bool.isRequired,
  children: PropTypes.node,
};
